import React from 'react';
import { motion } from 'framer-motion';

const animations = {
  // Start state: Invisible and shifted UP by 50px
  initial: { opacity: 0, y: -50 }, 
  
  // End state: Fully visible and in original position
  animate: { opacity: 1, y: 0 },   
  
  // Exit state: Fades out and slides DOWN by 50px
  exit: { opacity: 0, y: 50 },     
};

const AnimatedPage = ({ children }) => {
  return (
    <motion.div
      variants={animations}
      initial="initial"
      animate="animate"
      exit="exit"
      transition={{ duration: 0.5, ease: "easeOut" }} // Smooth easing
      style={{ width: '100%' }}
    >
      {children}
    </motion.div>
  );
};

export default AnimatedPage;